export const ENV = {
    DEV: /* #__PURE__ */ (() => !(typeof process !== 'undefined' && process.env.NODE_ENV === 'production'))(),
};
/**
 * The deep copy strategy
 *
 * Higher level indicates more accuracy but probably less performance.
 */
export var DeepCopyKind;
(function (DeepCopyKind) {
    /**
     * Avoid deep copy
     *
     * This avoids any copy, and recursive objects can be handled without any failing.
     * However, changing non-copied data will sometimes break the logic.
     */
    DeepCopyKind["None"] = "none";
    /**
     * Do a simple deep copy
     *
     * This simply clones each enumerable fields in an object to a new object.
     * It causes stack overflow in recursive objects.
     * Everything in prototypes is ignored.
     */
    DeepCopyKind["Simple"] = "simple";
    /**
     * Do a deep copy with recursion detection
     *
     * This clones each enumerable fields in an object to a new object.
     * It can handle recursive objects by recursive detection.
     * Everything in prototypes is ignored.
     */
    DeepCopyKind["SimpleWithRecursion"] = "simple-recursion";
})(DeepCopyKind || (DeepCopyKind = {}));
/**
 * The default options
 */
export const globalOptions = {
    defaultComponentSpace: null,
    externalComponent: false,
    templateEngine: null,
    styleScope: null,
    extraStyleScope: null,
    inheritStyleScope: false,
    hostNodeTagName: 'wx-x',
    multipleSlots: false,
    dynamicSlots: false,
    reflectToAttributes: false,
    writeFieldsToNode: true,
    writeIdToDOM: false,
    useMethodCallerListeners: false,
    idPrefixGenerator: null,
    pureDataPattern: null,
    dataDeepCopy: DeepCopyKind.Simple,
    propertyPassingDeepCopy: DeepCopyKind.Simple,
    listenerChangeLifetimes: false,
    virtualHost: false,
    propertyEarlyInit: false,
    propertyComparer: null,
    unknownPropertyHandler: null,
    throwGlobalError: false,
    writeExtraInfoToAttr: false,
    backendContext: null,
    devTools: null,
};
export const normalizeComponentOptions = (componentOptions, baseComponentOptions) => {
    const b = baseComponentOptions === undefined ? globalOptions : baseComponentOptions;
    if (componentOptions === undefined && b !== globalOptions) {
        return b;
    }
    const p = componentOptions !== null && componentOptions !== void 0 ? componentOptions : {};
    return {
        externalComponent: p.externalComponent !== undefined ? p.externalComponent : b.externalComponent,
        templateEngine: p.templateEngine !== undefined ? p.templateEngine : b.templateEngine,
        styleScope: p.styleScope !== undefined ? p.styleScope : b.styleScope,
        hostNodeTagName: p.hostNodeTagName !== undefined ? p.hostNodeTagName : b.hostNodeTagName,
        extraStyleScope: p.extraStyleScope !== undefined ? p.extraStyleScope : b.extraStyleScope,
        inheritStyleScope: p.inheritStyleScope !== undefined ? p.inheritStyleScope : b.inheritStyleScope,
        multipleSlots: p.multipleSlots !== undefined ? p.multipleSlots : b.multipleSlots,
        dynamicSlots: p.dynamicSlots !== undefined ? p.dynamicSlots : b.dynamicSlots,
        reflectToAttributes: p.reflectToAttributes !== undefined ? p.reflectToAttributes : b.reflectToAttributes,
        writeFieldsToNode: p.writeFieldsToNode !== undefined ? p.writeFieldsToNode : b.writeFieldsToNode,
        writeIdToDOM: p.writeIdToDOM !== undefined ? p.writeIdToDOM : b.writeIdToDOM,
        useMethodCallerListeners: p.useMethodCallerListeners !== undefined
            ? p.useMethodCallerListeners
            : b.useMethodCallerListeners,
        idPrefixGenerator: p.idPrefixGenerator !== undefined ? p.idPrefixGenerator : b.idPrefixGenerator,
        pureDataPattern: p.pureDataPattern !== undefined ? p.pureDataPattern : b.pureDataPattern,
        dataDeepCopy: p.dataDeepCopy !== undefined ? p.dataDeepCopy : b.dataDeepCopy,
        propertyPassingDeepCopy: p.propertyPassingDeepCopy !== undefined
            ? p.propertyPassingDeepCopy
            : b.propertyPassingDeepCopy,
        listenerChangeLifetimes: p.listenerChangeLifetimes !== undefined
            ? p.listenerChangeLifetimes
            : b.listenerChangeLifetimes,
        virtualHost: p.virtualHost !== undefined ? p.virtualHost : b.virtualHost,
        propertyEarlyInit: p.propertyEarlyInit !== undefined ? p.propertyEarlyInit : b.propertyEarlyInit,
        propertyComparer: p.propertyComparer !== undefined ? p.propertyComparer : b.propertyComparer,
        unknownPropertyHandler: p.unknownPropertyHandler !== undefined ? p.unknownPropertyHandler : b.unknownPropertyHandler,
    };
};
//# sourceMappingURL=global_options.js.map